module.exports = __webpack_public_path__ + "9546f4a9916889797e7c696c9f179bab.svg";